import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MdContent = _resolveComponent("MdContent")

  return (_openBlock(), _createBlock(_component_MdContent, {
    class: "md-content",
    restricted: $props.generating || $props.restricted,
    markdown: $data.visible_text
  }, null, 8 /* PROPS */, ["restricted", "markdown"]))
}